import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'SettingsThemeDomains',
  props: {
    domains: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    tenantId: {
      type: Number,
      default: -1,
      required: true
    }
  },
  data: function data() {
    return {
      errorMessage: '',
      domainInput: '',
      isDomainCheckBusy: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])),
  methods: {
    clearError: function clearError() {
      this.errorMessage = '';
    },
    isValidDomain: function isValidDomain(domain) {
      var ipTest = /^(?:(?:http[s]?)?:\/\/)?([1-9]{1}[0-9]{0,2})\.([1-9]{1}[0-9]{0,2})\.([1-9]{1}[0-9]{0,2})\.([1-9]{1}[0-9]{0,2})$/;

      if (ipTest.test(domain)) {
        // make sure it is a valid IPv4 address
        return domain.match(ipTest).slice(1).every(function (n) {
          return parseInt(n) >= 0 && parseInt(n) <= 255;
        });
      }

      var domainTest = /^((http(s?))?:\/\/)?[a-zA-Z0-9][a-zA-Z0-9-.]{1,62}(?:\.[a-zA-Z]{2,})+$/;
      return domainTest.test(domain.toLowerCase());
    },
    getDomainFromUrl: function getDomainFromUrl(domain) {
      var cleanDomain = domain.toLowerCase().trim().replace(/^(?:(?:http[s]?)?:\/\/)?/i, '').split(/\/+/).slice(0, 1).join('');
      return this.isValidDomain(cleanDomain) ? cleanDomain : null;
    },
    isAvailableDomain: function isAvailableDomain(domain) {
      var _this = this;

      return ApiService.getTheming(domain).then(function (result) {
        var lowercaseDomain = (domain || '').toLowerCase();
        var protocollessDomain = lowercaseDomain.replace(/^http(s?):\/\//g, '');
        return get(result, 'theme.tenantId') === undefined || parseInt(get(result, 'theme.tenantId') === _this.tenantId) || // NOTE: the themeing-fetch has a fallback to look up the hierarchy if neither for the tenant nor the domain
        // a theming was found. So check for the returned theme that it does not contain the domain yet,
        // IF it belongs to another tenant (aka the check just above)
        (get(result, 'theme.domains') || []).indexOf(protocollessDomain) < 0;
      });
    },
    addDomain: function addDomain() {
      var _this2 = this;

      // change domain to lowercase and remove anything that follows the actual domain
      // like "/#/system-settings" in "http://ui.127.0.0.1.xip.io/#/system-settings"
      var domain = this.getDomainFromUrl(this.domainInput);

      if (!domain) {
        // Sanitized Input is empty - Invalid Domain
        this.errorMessage = this.$i18n_t('accMgmt.tenant.errorDomainInvalid', {
          domain: this.domainInput
        });
        return;
      } else if (this.domains.includes(domain)) {
        // Domain already exists in this list on the current tenant
        this.domainInput = domain;
        this.errorMessage = this.$i18n_t('accMgmt.tenant.errorDomainDuplicate', {
          domain: domain
        });
        return;
      }

      this.isDomainCheckBusy = true;
      this.isAvailableDomain(domain).then(function (isThemeAvailable) {
        if (!isThemeAvailable) {
          // Domain is used in another tenant
          _this2.errorMessage = _this2.$i18n_t('accMgmt.tenant.errorDomainExists', {
            domain: domain
          });
        } else {
          _this2.domains.push(domain);

          _this2.domainInput = '';

          _this2.$emit('update', _this2.domains);
        }
      }).catch(function (error) {
        console.error(error.name === 'EXISTS');
        _this2.errorMessage = _this2.$i18n_t('accMgmt.tenant.errorDomainUnknown', {
          domain: domain
        });
      }).finally(function () {
        _this2.isDomainCheckBusy = false;
      });
    },
    deleteDomain: function deleteDomain(domain) {
      var cleanDomains = this.domains.filter(function (item) {
        return item !== domain;
      });
      this.$emit('update', cleanDomains);
    }
  }
};